import {
  SET_SUB_CATEGORY_PAGE_DATA,
  SET_SUB_CATEGORY_TOTAL_RECORDS,
  SET_SUB_CATEGORY_PAGE,
  EDIT_SUB_CATEGORY,
  ADD_SUB_CATEGORY,
  DELETE_SUB_CATEGORY,
  SUB_CATEGORY_LOADING,
  SUB_CATEGORY_FAILURE,
  GET_SUB_CATEGORY,
  SET_SUB_CATEGORY_REDIRECT_URL
} from "./sub-category-constant";

import {
  handleLoading,
  handleFailure,
  handleSetRedirectUrl,
  handleGetData,
  handleSetTotalRecords,
  handleSetPage,
  handleEditItem,
  handleAddItem,
  handleDeleteItems,
} from "../utils/reducerUtils";

// Initial state
const initialState = {
  subCategoryList: {},
  totalRecords: 0,
  totalPages: 0,
  currentPage: 1,
  loading: false,
  error: null,
  redirectTo: false,
};

export const subCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUB_CATEGORY_LOADING:
      return handleLoading(state, action);

    case SUB_CATEGORY_FAILURE:
      return handleFailure(state, action);

    case SET_SUB_CATEGORY_REDIRECT_URL:
      return handleSetRedirectUrl(state, action);

    case GET_SUB_CATEGORY:
      return handleGetData(state, action, "subCategoryList");

    case SET_SUB_CATEGORY_TOTAL_RECORDS:
      return handleSetTotalRecords(state, action);

    case SET_SUB_CATEGORY_PAGE:
      return handleSetPage(state, action);

    case ADD_SUB_CATEGORY:
      return handleAddItem(state, action, "subCategoryList", "subCategoryId");

    case EDIT_SUB_CATEGORY:
      return handleEditItem(state, action, "subCategoryList", "subCategoryId");

    case DELETE_SUB_CATEGORY:
      return handleDeleteItems(state, action, "subCategoryList", "subCategoryId");

    default:
      return state;
  }
};
